import { ColumnEditor } from 'LookupEditor/ColumnEditors/Base/ColumnEditor';

export class CurrencyColumnEditor extends ColumnEditor {
    Show(): void {}

    ToString() {
        return 'Currency';
    }
}
